import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
//import * as Session from '../../session'
import LoginFormView from '../components/LoginFormView'
import { currentUser } from '../../reducer';

import { submitLoginForm } from '../actions'

const mapStateToProps = (state) => {
  return {
    // initialValues: {email: "mittie@example.org", password:"password"},
    current_user_id: currentUser(state).get("id"),
    current_user: currentUser(state)
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: ({email,password}) => {
      dispatch(submitLoginForm(email,password,window.getCookie("udid")));
    }
  }
}

export const LoginForm = connect(mapStateToProps,mapDispatchToProps)(LoginFormView);

export default LoginForm;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/LoginForm.js